const REGEX_NUMBERS_MATCH = /\d+(?:[,.\u202F]\d+)*/ugm;
const getBracketedNumber = (formattedNumber) => formattedNumber.replace(REGEX_NUMBERS_MATCH, (found) => `(${found})`);
const formatterCache = {};
const getNumberFormatOptionsHash = (options, regionCode) => `${regionCode || ""}-${JSON.stringify(options)}`;
const getFormatterFromCache = (options, regionCode) => {
    const hash = getNumberFormatOptionsHash(options, regionCode);
    if (!formatterCache[hash]) {
        formatterCache[hash] = new Intl.NumberFormat(regionCode, options);
    }
    return formatterCache[hash];
};
export var UserPreferencesNegativeNumberFormatEnum;
(function (UserPreferencesNegativeNumberFormatEnum) {
    UserPreferencesNegativeNumberFormatEnum["MinusPrefixed"] = "minusPrefixed";
    UserPreferencesNegativeNumberFormatEnum["Bracketed"] = "bracketed";
})(UserPreferencesNegativeNumberFormatEnum || (UserPreferencesNegativeNumberFormatEnum = {}));
export const negativeNumberFormats = {
    [UserPreferencesNegativeNumberFormatEnum.Bracketed]: {
        format(value, regionCode, options) {
            const formatOptions = options ?? {};
            Object.assign(formatOptions ?? {}, { signDisplay: "never" });
            const formattedNumber = getFormatterFromCache(formatOptions, regionCode).format(value);
            if (value < 0) {
                return getBracketedNumber(formattedNumber);
            }
            return formattedNumber;
        }
    },
    [UserPreferencesNegativeNumberFormatEnum.MinusPrefixed]: {
        format: (value, regionCode, options) => {
            const formatOptions = options ?? {};
            if (options?.signDisplay === null) {
                Object.assign(formatOptions, { signDisplay: "auto" });
            }
            return getFormatterFromCache(formatOptions, regionCode).format(value);
        }
    }
};
